export default __webpack_public_path__ + "static/media/lubricants.aa884e23.svg";